// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2E6OF","headerImage":"Header_headerImage__2JsCU"};